// SceneProgressDots — a tiny "○ ○ ○" indicator in the bottom-left that
// shows the current scene index. Seven dots (one per scene); the active
// one fills and glows mint. Click a dot to jump to that scene.

import { useCallback, useEffect, useState } from 'react';
import { SCENES } from './planetSections';
import { onChapterNavClick } from '../utils/analytics';
import './scene-progress.css';

function scrollToProgress(target: number) {
  if (typeof window === 'undefined') return;
  const max = document.documentElement.scrollHeight - window.innerHeight;
  if (max <= 0) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({
    top: max * target,
    behavior: reduced ? 'auto' : 'smooth',
  });
}

export function SceneProgressDots() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let last = window.__planetSceneIndex ?? 0;
    setIdx(last);
    const id = window.setInterval(() => {
      const cur = window.__planetSceneIndex ?? 0;
      if (cur !== last) {
        last = cur;
        setIdx(cur);
      }
    }, 200);
    return () => window.clearInterval(id);
  }, []);

  const jump = useCallback((i: number) => {
    const s = SCENES[i];
    // Aim for the middle of the target scene so its HUD is fully shown.
    scrollToProgress((s.start + s.end) / 2);
    onChapterNavClick(s.key);
  }, []);

  return (
    <div className="scene-progress" aria-hidden="true">
      {SCENES.map((s, i) => (
        <button
          key={s.key}
          type="button"
          className={['scene-progress__dot', i === idx ? 'is-active' : '']
            .filter(Boolean)
            .join(' ')}
          onClick={() => jump(i)}
          aria-label={`Go to ${s.name}`}
          title={s.name}
        />
      ))}
    </div>
  );
}

export default SceneProgressDots;
